import React from "react";
import { AccountForm } from "../../../molecules/AccountForms";
import { ImageUploadArea } from "../../../molecules/ImageUploadArea";
import classNames from "classnames";
import {
  FormGroup,
  Callout,
  Intent,
  TextArea,
  InputGroup,
  HTMLSelect as Select,
  Checkbox
} from "@blueprintjs/core";
import styles from "./OrganizationInfo.module.scss";

function OrganizationInfoForm({
  image,
  bio,
  name,
  website,
  statesList,
  state,
  checkbox,
  setState,
  contactNumber,
  taxId,
  setTaxId,
  setContactNumber,
  type,
  city,
  zip,
  street,
  setCity,
  setZip,
  setStreet,
  setType,
  error,
  disabled,
  isFormValid,
  isTaxIdProvided,
  typeDisabled,
  onImageChange,
  setBio,
  setName,
  setWebsite,
  setCheckbox,
  typeList,
  onSubmit,
  buttonText,
  updateLoading,
  isNmiAccount
}) {
  return (
    <AccountForm
      headerText="Organization Info"
      onboardingHeaderText={true}
      buttonText={buttonText}
      disabled={disabled}
      loading={updateLoading}
      onSubmit={onSubmit}
      fullButton={true}
    >
      {error && (
        <Callout
          intent={Intent.WARNING}
          title={error.title}
          style={{ marginBottom: "1em" }}
          icon={null}
        >
          {error.message}
        </Callout>
      )}

      <ImageUploadArea image={image} onImageChange={onImageChange} />

      <div className={styles.row}>
        <div className={styles.column}>
          <FormGroup label="NAME" labelFor="name">
            <InputGroup
              id="name"
              type="text"
              value={name}
              onChange={setName}
              placeholder="Organization name"
              intent={!isFormValid && !name ? Intent.DANGER : Intent.NONE}
            />
          </FormGroup>
        </div>

        <div className={styles.column}>
          <FormGroup label="TYPE" labelFor="type" className={styles.fldSelect}>
            <Select
              options={typeList}
              value={type || ""}
              onChange={setType}
              disabled={typeDisabled}
              className={!isFormValid && !type ? styles.invalidSelect : ""}
            />
          </FormGroup>
        </div>
      </div>

      <div className={styles.row}>
        <div className={styles.column}>
          <FormGroup label="WEBSITE" labelFor="website">
            <InputGroup
              id="website"
              type="text"
              value={website}
              onChange={setWebsite}
              placeholder="videosquirrel.app"
              intent={!isFormValid && !website ? Intent.DANGER : Intent.NONE}
            />
          </FormGroup>
        </div>

        <div className={styles.column}>
          <FormGroup label="CONTACT NUMBER" labelFor="contact">
            <InputGroup
              id="contact"
              type="text"
              value={contactNumber}
              onChange={setContactNumber}
              placeholder="123 456 7890"
              intent={
                !isFormValid && !contactNumber ? Intent.DANGER : Intent.NONE
              }
            />
          </FormGroup>
        </div>

        {!isNmiAccount && (
          <div className={styles.column}>
            <FormGroup label="TAX ID" labelFor="tax">
              <InputGroup
                id="tax"
                type="text"
                value={taxId}
                disabled={isTaxIdProvided}
                onChange={setTaxId}
                placeholder="6576575"
                intent={!isFormValid && !taxId ? Intent.DANGER : Intent.NONE}
              />
            </FormGroup>
          </div>
        )}
      </div>

      <div className={styles.row}>
        <div className={styles.column}>
          <FormGroup label="ADDRESS" labelFor="address">
            <InputGroup
              id="address"
              type="text"
              value={street}
              onChange={setStreet}
              placeholder="13th Street. 47 W 13th St, New York"
              intent={!isFormValid && !street ? Intent.DANGER : Intent.NONE}
            />
          </FormGroup>
        </div>
      </div>

      <div className={styles.row}>
        <div className={styles.column}>
          <FormGroup label="CITY" labelFor="city">
            <InputGroup
              id="city"
              type="text"
              value={city}
              onChange={setCity}
              placeholder="New York"
              intent={!isFormValid && !city ? Intent.DANGER : Intent.NONE}
            />
          </FormGroup>
        </div>

        <div className={styles.column}>
          <FormGroup
            label="STATE"
            labelFor="state"
            className={styles.fldSelect}
          >
            <Select
              options={statesList}
              value={state || ""}
              onChange={setState}
              className={!isFormValid && !state ? styles.invalidSelect : ""}
            />
          </FormGroup>
        </div>

        <div className={styles.column}>
          <FormGroup label="ZIP" labelFor="zip">
            <InputGroup
              id="zip"
              type="text"
              value={zip}
              onChange={setZip}
              placeholder="10003"
              intent={!isFormValid && !zip ? Intent.DANGER : Intent.NONE}
            />
          </FormGroup>
        </div>
      </div>

      <div className={styles.row}>
        <div className={styles.column}>
          <FormGroup label="BIO" labelFor="bio-input">
            <TextArea
              id="bio-input"
              value={bio || ""}
              onChange={setBio}
              placeholder="Please provide a few sentences about your business or organization"
              className={classNames("bp3-fill", styles.organizationBio)}
              intent={!isFormValid && !bio ? Intent.DANGER : Intent.NONE}
            />
          </FormGroup>
        </div>
      </div>

      <p className={styles.f12}>
        This will be displayed to customers alongside your product info during
        checkout.
      </p>

      <Callout icon={"info-sign"} className={styles.note}>
        Under the penalty of perjury I certify that the information provided is
        correct and &nbsp; that i'm duly authorized to represent the
        organization on their behalf.
      </Callout>

      <FormGroup labelFor={"confirm"}>
        <Checkbox
          checked={checkbox}
          onChange={() => setCheckbox(!checkbox)}
          className={styles.checkbox}
          label={
            <span>
              I agree to all&nbsp;
              <a href="https://videosquirrel.app/tos">
                Terms & Conditions
              </a>{" "}
              and&nbsp;
              <a href="https://videosquirrel.app/privacy">Privacy Policy</a>.
            </span>
          }
          id="confirm"
        />
      </FormGroup>
    </AccountForm>
  );
}

export default OrganizationInfoForm;
